export default __webpack_public_path__ + "assets/images/424431e284d8d4b241c64a0982e43f64.jpg";